import { useUpload } from 'storfox-api-hooks'

import * as API from '~/constants/api'

export const useImageUpload = () => {
  return useUpload(API.FILE_UPLOAD)
}
